<template>
    <section id="message" class="container flex items-center justify-center text-center pt-20 pb-20">
        <div class="container flex flex-col items-center justify-center">
            <img src="@img/defaults/error.webp" title="error" alt="error"
                 height="300px" width="auto" class="mb-5">
            <h1 class="text-2xl md:text-3xl font-bold mb-2">{{ title }}</h1>
            <div class="font-medium mb-4">{{ description }}</div>
            <p class="h6 font-medium">
                Вы можете попробовать вернуться
                <br class="block md:hidden">
                <Link v-if="status === 404" :href="'/'">
                    <span class="text-indigo-600 font-bold underline">
                        на главную страницу
                    </span>
                </Link>
            </p>
        </div>
    </section>
</template>

<script>
import {computed, defineProps} from 'vue';
import ErrorLayout from "@/js/Shared/ErrorLayout.vue"
import {Link} from "@inertiajs/vue3";

export default {
    layout: ErrorLayout,
    props: {
        status: Number
    },
    setup(props) {
        const title = computed(() => {
            return {
                503: '503: Сервис временно недоступен',
                500: '500: Ошибка сервера',
                404: '404: Страница не найдена',
                403: '403: Доступ запрещён',
            }[props.status];
        });

        const description = computed(() => {
            return {
                503: 'Извините, мы проводим техническое обслуживание. Пожалуйста, зайдите позже.',
                500: 'Упс, что-то пошло не так на наших серверах.',
                404: 'Извините, страница, которую вы ищете, не найдена.',
                403: 'Извините, у вас нет доступа к этой странице.',
            }[props.status];
        });

        const status = props.status
        return {
            title,
            description,
            status,
        };
    },
    components: {
        Link
    }
};
</script>
